import React from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toTitleCase, underscoreToTitleCase } from 'app/shared/util/text-util';
import { JourneyStatus } from 'app/shared/model/enumerations/journey-status.model';

const JourneyCard = ({ status, subtitle, location, destination, time, createdAgo, name, onClick }) => (
  <Card className="mb-3">
    <CardHeader className="bg-white">
      <Row>
        <Col md={6}>
          <h5 className={`mb-0 text-${status === JourneyStatus.AWAITING_PICKUP ? 'danger' : 'primary'}`}>{underscoreToTitleCase(status)}</h5>
        </Col>
        <Col md={6} className="text-right">
          <FontAwesomeIcon icon="clock" className="ml-2" />
          &nbsp;
          {createdAgo} ago
        </Col>
      </Row>
    </CardHeader>
    <CardBody onClick={onClick}>
      <div className="text-muted mb-3">{subtitle}</div>
      <h5 className="mb-4">{toTitleCase(name)}</h5>
      <div>
        <Row>
          <Col md={4}>{location}</Col>
          <Col md={4} className="text-center">
            { `--${time}-->`}
          </Col>
          <Col md={4} className="text-right">
            {destination}
          </Col>
        </Row>
      </div>
    </CardBody>
  </Card>
);

export default JourneyCard;
